import { render } from "./MessageDetailItem.vue?vue&type=template&id=f31dcb58&scoped=true"
import script from "./MessageDetailItem.vue?vue&type=script&lang=js"
export * from "./MessageDetailItem.vue?vue&type=script&lang=js"

import "./MessageDetailItem.vue?vue&type=style&index=0&id=f31dcb58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f31dcb58"]])

export default __exports__